import script from "./ColorSizeTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorSizeTab.vue?vue&type=script&setup=true&lang=js"

import "./ColorSizeTab.vue?vue&type=style&index=0&id=d5c5a00a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c5a00a"]])

export default __exports__